{
  "version": 1,
  "asset_id": "c21ade0d-70a6-4c61-aa66-3283e68a4cab",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c21ade0d-70a6-4c61-aa66-3283e68a4cab/loc-dallas-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c21ade0d-70a6-4c61-aa66-3283e68a4cab/loc-dallas-1280.avif",
  "original_filename": "loc-dallas-1280.avif",
  "size": 66791,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:20Z"
}
